<template>
  <div class="mainHeader">
    <nav class="navbar navbar-light bg-transparent">
      <a class="navbar-brand" href="\">
        <img src="img/brand/sydneyMetroLogo.png" class="siteLogoLeft">
      </a>
      <div class="navbar-brand">
        <!--<img src="img/assets/logos/TfNSW.svg" class="siteLogoRight">-->
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // year: new Date().getFullYear()
      // year: 2020
    };
  }
};
</script>
<style scoped>
.mainHeader {
  background-color:transparent;
}
.siteLogoLeft {
  height: 6vh;
  margin-left: 0.5vw;
  margin-top: 0.5vh;
}
.siteLogoRight {
  height: 6vh;
  margin-right: 1.2vw;
  /* margin-top: 4vh; */
}
</style>
